import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

import t from '../utils/translate';
import { getColumns, checkUserLevel } from '../utils/challengeUtils';
import * as challengeSubTypes from '../constants/challengeSubTypes';

function getChallenges(challenges, showCustom, showH2H, userSportLevels) {
  return [
    {
      key: 'challenges',
      title: t('Recommended Challenges'),
      challenges: challenges.filter(
        ch =>
          ch.maxEntriesPerPerson > ch.userEntryIds.length &&
          (showH2H ? true : ch.subTypeId !== challengeSubTypes.H2H) &&
          (showCustom
            ? true
            : ch.ownerType !== 'users' || ch.subTypeId === challengeSubTypes.H2H) &&
          checkUserLevel(ch.userLevels, get(`${ch.sportId}.level`, userSportLevels))
      ),
      columns: getColumns({
        compatibleChallenges: true
      }),
      emptyTitle: t('No Available Challenges'),
      emptyMessage: t('There are no other challenges of this type'),
      alwaysShow: true
    }
  ];
}

const compatibleChallengesSelector = createSelector(
  get('compatibleChallenges.challenges'),
  get('compatibleChallenges.showCustom'),
  get('compatibleChallenges.showH2H'),
  get('user.currentUser.sport_levels'),
  getChallenges
);

export default compatibleChallengesSelector;
